import { SCALES, SCALE_IDS, type ScaleId } from '@theory/scales';
import { useAppStore } from '@app/store/useAppStore';
import shared from './dropdownShared.module.css';

export function ScaleDropdown() {
  const scale = useAppStore((s) => s.selectedScaleId);
  const setSelectedScale = useAppStore((s) => s.setSelectedScale);

  return (
    <select
      className={shared.select}
      value={scale}
      onChange={(e) => setSelectedScale(e.target.value as ScaleId)}
      aria-label="Scale"
    >
      {SCALE_IDS.map((id) => (
        <option key={id} value={id}>
          {SCALES[id].displayName}
        </option>
      ))}
    </select>
  );
}
